export default function (app) {
  app.controller('klEnterpriseCancelledCtrl', [
    '$state',
    '$window',
    'klSubscriptionService',
    function ($state) {
      this.back = function () {
        $state.go('subscription');
      };
    },
  ]);
}
